import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './section.less';
import classnames from 'classnames';
import InlineSVG from 'react-inlinesvg';

class Section extends Component {
  render() {
    return (
      <div className={classnames('section', this.props.className)}>
        {this.props.title && (
          <h1 className={'section__title'}>
            {this.props.icon && (
              <InlineSVG src={this.props.icon} className={'icon'} />
            )}
            {this.props.title}
            {this.props.extra && (
              <div className={'extra'}>{this.props.extra}</div>
            )}
          </h1>
        )}
        {this.props.subtitle && (
          <div className={'section__subtitle'}>{this.props.subtitle}</div>
        )}
        <div style={this.props.style} className={'section__content'}>
          {this.props.children}
        </div>
      </div>
    );
  }
}

Section.propTypes = {
  title: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  subtitle: PropTypes.string,
  icon: PropTypes.string,
  style: PropTypes.object,
  extra: PropTypes.element,
  className: PropTypes.string
};

export default Section;
